import React from "react";
import Box, { BoxProps } from "@mui/material/Box";
import { SxProps, Theme } from "@mui/material/styles";

import { blue050, blue100 } from "styles";

interface PageNetBackgroundProps {
  children: React.ReactNode;
  sx?: BoxProps["sx"];
  contentSx?: BoxProps["sx"];
  beforeSx?: React.CSSProperties;
  afterSx?: React.CSSProperties;
}

const PageNetBackground: React.FC<PageNetBackgroundProps> = ({
  children,
  sx,
  contentSx,
}) => {
  const styles: { [key: string]: SxProps<Theme> } = {
    wrapper: {
      position: "relative",
      flex: 1,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      backgroundColor: blue050,
      backgroundImage: `
        radial-gradient(circle, rgba(0, 0, 255, 0.20) 0%, transparent 70%),
        radial-gradient(circle, rgba(0, 0, 255, 0.20) 0%, transparent 70%),
        linear-gradient(to left, ${blue100} 2px, transparent 2px),
        linear-gradient(to top, ${blue100} 2px, transparent 2px)
      `,

      backgroundPosition: `
        right -700px top -800px,
        left -700px bottom -1000px,
        140px 40px,
        140px 40px
      `,

      backgroundSize: `
        1350px 1350px,
        1350px 1350px,
        220px 156px,
        220px 156px
      `,

      backgroundRepeat: "no-repeat, no-repeat, repeat, repeat",
      ...sx,
    },
    content: {
      position: "relative",
      zIndex: 1,
      width: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      flex: 1,
      ...contentSx,
    },
  };

  return (
    <Box sx={styles.wrapper}>
      <Box sx={styles.content}>{children}</Box>
    </Box>
  );
};

export default PageNetBackground;
